/**
 * The one MRN label for the app (PROD-3203 M3).
 *
 * Some MRNs arrive from the API already prefixed ("MRN 000-100-123", e.g. the
 * PROD-797 patient-creation default); others are bare ("000-100-123"). Each
 * screen used to add "MRN " itself, and the ones that forgot to check showed
 * "MRN MRN 000-100-…". Every label goes through here instead.
 *
 *   formatMrnLabel('000-100-123')      -> 'MRN 000-100-123'
 *   formatMrnLabel('MRN 000-100-123')  -> 'MRN 000-100-123'
 *   formatMrnLabel('mrn: 000-100-123') -> 'MRN 000-100-123'
 *   formatMrnLabel('MRN0001')          -> 'MRN 0001'
 *   formatMrnLabel('  ') / null        -> null
 */
const MRN_PREFIX = /^\s*MRN(?:[:\s-]*)/i;

export function formatMrnLabel(mrn: string | null | undefined): string | null {
  const bare = (mrn ?? '').replace(MRN_PREFIX, '').trim();
  return bare ? `MRN ${bare}` : null;
}
